// s02-contact.js

import { navbar_active_menu, form_validate, postData, show_modal } from '../utils';
import { BASEURL } from "../AppState.js"

import selfHtml from './s02-contact.html' with { type: 'text' };;

var root

export async function init(module_root, args) {

    module_root.innerHTML = selfHtml;

    root = module_root;

    navbar_active_menu(".contact_us");

    // Bootstrap form validation and onClick action
    form_validate(root, async () => {
        submit_feedback(root)
    });

}

// -------------------------------------------------

async function submit_feedback(el) {

    const spinner_border = el.querySelector('.spinner-border')

    spinner_border.style.display = "" // show spinner

    el.disabled = true

    try {

        const payload = {
            feedback_name: document.getElementById("feedback_name").value,
            feedback_email: document.getElementById("feedback_email").value,
            feedback_subject: document.getElementById("feedback_subject").value,
            feedback_category: document.getElementById("feedback_category").value,
            feedback_subject: document.getElementById("feedback_subject").value,
            feedback_suggestion: document.getElementById("feedback_suggestion").value,
            feedback_priorityMedium: document.getElementById("feedback_priorityMedium").checked,
            feedback_priorityHigh: document.getElementById("feedback_priorityHigh").checked,
            feedback_priorityLow: document.getElementById("feedback_priorityLow").checked,
            feedback_newsletter: document.getElementById("feedback_newsletter").checked,
        }

        const data = await postData(BASEURL.api + '/feedback', payload);

        show_modal("Thank You", "Your feedback has been sent!", { action: "redirect", url: "./", btn_text: "Close" })
    } catch (err) {
        console.log(err)
        show_modal("Error", err)
    } finally {
        spinner_border.style.display = 'none' // show spinner
        el.disabled = false
    }


}